import React, { Component } from 'react'
import { withStyles } from 'material-ui/styles'
import TextField from 'material-ui/TextField'
import Button from 'material-ui/Button'
import LocationsControls from '../locations/LocationsControls'
import CircularProgress from 'material-ui/Progress/CircularProgress'
import green from 'material-ui/colors/green'
import { FormControlLabel } from 'material-ui/Form'
import Checkbox from 'material-ui/Checkbox'
import Input from 'material-ui/Input'
import { SelectWrapped, style as selectStyle } from '../common/SelectWrapped'

const style = theme => ({
  root: {
    flexDirection: 'column'
  },
  wrapper: {
    margin: theme.spacing.unit,
    position: 'relative'
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '20px',
    left: '60px',
    marginTop: -12,
    marginLeft: -12
  },
  ...selectStyle(theme)
})

class LocationForm extends Component {
  constructor (props) {
    super(props)
    this.state = {}
  }

  render () {
    const {
      classes,
      name,
      contactName,
      contactPhone,
      street,
      city,
      country,
      latitude,
      longitude,
      pickup,
      onFormChange,
      onLocationSave,
      requestOngoing,
      successMsg,
      clientId,
      clients
    } = this.props

    const countries = ['Nigeria', 'Kenya']

    return (
      <div>
        <LocationsControls />
        <form noValidate autoComplete='off' className={classes.root}>
          <TextField
            id='name'
            label='Location Name'
            margin='normal'
            fullWidth
            value={name}
            onChange={e => onFormChange('name', e.target.value)}
          />

          <TextField
            id='contactName'
            label='Location Contact Name'
            margin='normal'
            fullWidth
            value={contactName}
            onChange={e => onFormChange('contactName', e.target.value)}
          />

          <TextField
            id='contactPhone'
            label='Location Contact Phone'
            margin='normal'
            type='number'
            fullWidth
            value={contactPhone}
            onChange={e => onFormChange('contactPhone', e.target.value)}
          />

          <TextField
            id='street'
            label='Street'
            margin='normal'
            fullWidth
            value={street}
            onChange={e => onFormChange('street', e.target.value)}
          />

          <TextField
            id='city'
            label='City'
            margin='normal'
            fullWidth
            value={city}
            onChange={e => onFormChange('city', e.target.value)}
          />

          <Input
            fullWidth
            inputComponent={SelectWrapped}
            inputProps={{
              classes,
              value: country,
              multi: false,
              onChange: value => onFormChange('country', value),
              placeholder: 'Select Country',
              instanceId: 'react-select-chip',
              id: 'react-select-chip-client',
              name: 'react-select-chip',
              simpleValue: true,
              options: countries.map(country => ({
                label: country,
                value: country
              })) // an array of countries
            }}
          />

          <Input
            fullWidth
            inputComponent={SelectWrapped}
            inputProps={{
              classes,
              value: clientId,
              multi: false,
              onChange: value => onFormChange('clientId', value),
              placeholder: 'Select Client',
              instanceId: 'react-select-chip',
              id: 'react-select-chip-client',
              name: 'react-select-chip',
              simpleValue: true,
              options: clients.map(client => ({
                value: client._id,
                label: client.name
              }))
            }}
          />

          <TextField
            id='latitude'
            label='Latitude'
            type='number'
            margin='normal'
            fullWidth
            value={latitude}
            onChange={e => onFormChange('latitude', e.target.value)}
          />
          <TextField
            id='longitude'
            label='Longitude'
            type='number'
            margin='normal'
            fullWidth
            value={longitude}
            onChange={e => onFormChange('longitude', e.target.value)}
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={pickup}
                onChange={e => onFormChange('pickup', e.target.checked)}
              />
            }
            label='Pick up location'
          />

          <div className={classes.wrapper}>
            <Button
              disabled={
                name === '' ||
                contactName === '' ||
                !contactPhone ||
                street === '' ||
                city === '' ||
                Math.abs(latitude) <= 0 ||
                Math.abs(longitude) <= 0 ||
                !clientId ||
                requestOngoing
              }
              color='primary'
              variant='raised'
              onClick={onLocationSave}
            >
              Save Location
            </Button>
            &nbsp;
            {requestOngoing && (
              <CircularProgress size={24} className={classes.buttonProgress} />
            )}
            {!requestOngoing && successMsg}
          </div>
        </form>
      </div>
    )
  }
}

LocationForm.defaultProps = {
  name: '',
  contactName: '',
  contactPhone: undefined,
  city: '',
  country: 'Nigeria',
  street: '',
  pickup: false,
  latitude: 0,
  longitude: 0
}

export default withStyles(style)(LocationForm)



// WEBPACK FOOTER //
// ./src/locations/LocationForm.js